<template>
  <div class="footer-bar">

    <div class="footer-bar-nav">
      <img src="../assets/mikmak-logo-white-new.png" alt="MikMak">

      <div class="footer-bar-nav-links">
        <a href="http://mikmak.tv#attach">Platform</a>
        <a href="http://mikmak.tv#studios">Studios</a>
        <a href="http://mikmak.tv#press">Press</a>
        <router-link :to="'/about'">about</router-link>
        <router-link :to="'/careers'">careers</router-link>
        <router-link :to="'/privacy'">privacy policy</router-link>
      </div>
    </div>

    <!-- <a href="https://app.adjust.com/k14ghn" class="app-store-img" target="new">
      <img src="../assets/app-store.png" alt="">
    </a> -->

    <span class="footer-social-icons">
      <a href="https://instagram.com/MikMakTV/" target="new"><i class="fa fa-instagram" aria-hidden="true"></i></a>
      <a href="https://www.facebook.com/MikMakdotTV" target="new"><i class="fa fa-facebook" aria-hidden="true"></i></a>
      <a href="https://twitter.com/mikmaktv" target="new"><i class="fa fa-twitter" aria-hidden="true"></i></a>
      <a href="https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w" target="new"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
    </span>

    <span class="footer-copyright">&copy 2015-2018 TIPO Entertainment, Inc.</span>
 </span>

  </div>

</template>

<script>

export default {
  mounted() {},
  methods: {},
  computed: {
    links() {
      return this.$store.state.headerLinks
    }
  },
  watch: {}
}
</script>

<style scoped>

  .footer-bar {
    display: block;
    padding: 12px;
    background: black;
  }

  .footer-bar-nav,
  .footer-bar-contact-form {
    vertical-align: top;
  }

  .footer-bar-nav {
    display: inline-block;
    padding: 24px;
  }

  .footer-bar-nav img {
    display: block;
    width: 150px;
  }

  .footer-bar-nav-links {
    display: inline-block;
  }

  .footer-bar-nav-links a {
    font-family: 'Work Sans', sans-serif;
    display: block;
    text-transform: lowercase;
    text-decoration: none;
    color: #00BFBD;
    font-weight: lighter;
    font-size: 24px;
    margin: 12px 0;
  }

  .footer-copyright {
    font-family: 'Work Sans', sans-serif;
    display: block;
    color: white;
    font-size: 12px;
    margin: 0 auto;
    text-align: center;
    padding: 24px;
  }

  .app-store-img img {
    display: block;
    width: 150px;
    margin: 12px auto;
    cursor: pointer;
  }

  .footer-social-icons {
    display: block;
    text-align: center;
    margin-top: 48px;
    transition: ease-in 0.125s;
  }

  .footer-social-icons i:hover {
    opacity: 0.8;
  }

  .footer-social-icons i {
    display: inline-block;
    color: #00BFBD;
    margin: 12px;
  }

</style>



// WEBPACK FOOTER //
// FooterBar.vue?00cadfbb